import script from "./DocItemTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DocItemTable.vue?vue&type=script&setup=true&lang=js"

import "./DocItemTable.vue?vue&type=style&index=0&id=b2429f36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2429f36"]])

export default __exports__